import { AxiosInstance } from "../utils/AxiosInstance";
import {
  CreateOrganizationRequest,
  CreditData,
} from "js/pages/Organization/types";
import { GeneralOrganizationData } from "js/components/Organization/types";
import { PaginationTable } from "js/components/types";

export const getOrganization = async () => {
  const { data } = await AxiosInstance.get(`/v1/organizations/`);
  return data;
};
export const updateOrganization = async (values: GeneralOrganizationData) => {
  const { data } = await AxiosInstance.put(`/v1/organizations/update`, values);
  return data;
};

export const getMembers = async () => {
  const { data } = await AxiosInstance.get(`/v1/organizations/members`);
  return data;
};
export const addMember = async (email: string) => {
  const { data } = await AxiosInstance.post(`/v1/organizations/members/add`, {
    email: email,
  });
  return data;
};

export const deleteMember = async (memberId: string) => {
  await AxiosInstance.delete(`/v1/organizations/members/${memberId}/delete`);
};

export const getCredits = async () => {
  const { data } = await AxiosInstance.get(`/v1/organizations/quotes`);
  return data;
};

export const updateCredits = async (data: CreditData) => {
  await AxiosInstance.put(`/v1/organizations/quotes/update`, data);
};

export const getAdvisorApiKeys = async () => {
  const { data } = await AxiosInstance.get(`/v1/organizations/developers/api`);
  return data;
};

export const getOrganizationReports = async (
  pagination: PaginationTable,
  filter: string = "",
) => {
  const { data } = await AxiosInstance.get(
    `v1/reports/organization?filter=${filter}`,
    {
      params: {
        limit: pagination.pageSize,
        offset: (pagination.current - 1) * pagination.pageSize,
      },
    },
  );
  return data;
};

export const getOrganizationTenantReports = async (
  pagination: PaginationTable,
  filter: string = "",
) => {
  const { data } = await AxiosInstance.get(
    `v1/tenants/reports/organization?filter=${filter}`,
    {
      params: {
        limit: pagination.pageSize,
        offset: (pagination.current - 1) * pagination.pageSize,
      },
    },
  );
  return data;
};

export const createOrganization = async (
  requestData: CreateOrganizationRequest,
) => {
  const { data } = await AxiosInstance.post(
    `v1/organizations/create`,
    requestData,
  );
  return data;
};

export const inviteToOrganization = async (emails: string[]) => {
  await AxiosInstance.post("v1/organizations/invite", { emails });
};

export const joinToOrganization = async (inviteToken: string) => {
  try {
    await AxiosInstance.post("v1/organizations/join", {
      invite_token: inviteToken,
    });
  } catch (err: any) {
    throw err;
  }
};
